<template>
    <div>
        <div class="row">
            <div class="col">
                <label>{{ $t('Patient') }}</label>
                <b-form-input
                    id="customerFieldInput"
                    type="text"
                    :placeholder="$t('Name Last Middle name or Phone')"
                    v-uppercase
                    autocomplete="off"
                    :autofocus="true"
                    @focus="showNameSearch=true"
                    @blur="showNameSearch=false"
                    v-model="customer.name"
                    class="form-control"
                />

                <b-form-invalid-feedback
                    :state="validation('customerId')">
                    {{ errorMsg }}
                </b-form-invalid-feedback>

                <CustomerSearchResults
                    :is-data-loading="areDataLoading"
                    :current-focus="currentFocus"
                    :customers="customers"
                    :shown="showNameSearch && customer.name && (customer.name.length > 0)"
                    @input="existingCustomerSelected($event.customerId)"
                />
            </div>
        </div>
        <div class="row mt-4" v-if="showPhone">
            <div class="col-sm-12 col-md-4 mb-3 mb-md-0" v-if="showPhone">
                <label>{{ $t('Phone') }}</label>
                <phone-field v-model="customer.phone"
                             :errorMsg="errors.phone"
                             :state="validation( 'phone')"
                             @focus="showPhoneSearch=true"
                             @blur="showPhoneSearch=false"
                             type="text"
                />
                <CustomerSearchResults
                    :is-data-loading="areDataLoading"
                    :current-focus="currentFocus"
                    :customers="customers"
                    :shown="showPhoneSearch && customer.phone && (customer.phone.length > 9)"
                    @input="existingCustomerSelected($event.customerId)"
                />
            </div>
            <div class="col-md-4 col-sm-12 mb-3 mb-md-0">
                <!-- <date-picker :label="$t('Birthdate')" :calendarOptions="calendarOptions" v-model="customer.birth_date"></date-picker> -->
                <label>{{ $t('Birthdate') }}</label>
                <input type="date" class="form-control" :max="calendarOptions.maxDate" v-model="customer.birth_date"/>
            </div>
            <div class="col-md-4 col-sm-12">
                <b-form-group :label="$t('Gender')">
                    <b-form-radio-group
                        v-model="customer.gender"
                        :options="[{ text: $t('Male'), value: 'male' },{ text: $t('Female'), value: 'female' }]"
                        name="radioInline"
                    ></b-form-radio-group>
                </b-form-group>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Avatar from '@/components/Avatar.vue'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'
import PhoneField from '@/components/PhoneField.vue'
import CustomerSearchResults from "./CustomerSearchResults";

export default {
    components: {
        CustomerSearchResults,
        Avatar,
        PhoneField,

    },
    mixins: [modalMixins],
    props: {
        errors: {},
        errorMsg: {}
    },
    data() {
        return {
            query: null,
            data: {},
            calendarOptions: {
                altFormat: "m/d/Y",
                allowInput: true,
                maxDate: this.$moment().format('Y-MM-DD'),
            },
            currentFocus: 0,
            showNameSearch: false,
            showPhoneSearch: false,
            showPhone: false,
            customer: {},
            params: {
                query: {
                    $limit: 3,
                    $sort: {
                        createdAt: -1
                    }
                }
            },
            pendingPromise: null
        }
    },
    computed: {
        ...mapState('customers', { areDataLoading: 'isFindPending' }),
        ...mapGetters('customers', { findCustomersInStore: 'find' }),
        customers() {
            const query = Object.assign({}, this.params.query)
            delete query.first_name;
            delete query.last_name;
            delete query.phone;
            return this.findCustomersInStore({ query }).data;
        },

    },
    destroyed() {
        window.removeEventListener("keyup", this.listener, true);
    },
    created() {
        // this.fetchCustomers();
        window.addEventListener('keyup', this.listener, true);
    },
    watch: {
        customer: {
            handler: debounce(async function (newVal) {
                if (this.pendingPromise){
                    await this.pendingPromise;
                    this.pendingPromise = null;
                }
                this.clearCustomers();

                if (this.showNameSearch && newVal.name && newVal.name.length > 0) { //search only by name, if no phone
                    this.params.query.$limit = 10;
                    this.params.query = { ...this.params.query, ...this.$customersSearch(newVal.name) };
                } else if (this.showPhoneSearch && newVal.phone && newVal.phone.length > 9) { // search by phone, ignoring name
                    this.params.query.$limit = 10;
                    delete this.params.query.$or;
                    delete this.params.query.first_name;
                    delete this.params.query.last_name;
                    this.params.query = { ...this.params.query, phone: newVal.phone };
                } else {
                    delete this.params.query.$or;
                    delete this.params.query.first_name;
                    delete this.params.query.last_name;
                    delete this.params.query.phone;
                    this.params.query.$limit = 3;
                }
                this.showPhone = true;

                this.updateValue(newVal);
                this.pendingPromise = this.fetchCustomers();
            }, 300),
            deep: true
        },
    },
    methods: {

        ...mapActions('customers', { findCustomers: 'find' }),
        ...mapMutations('customers', {
            clearCustomers: 'clearAll'
        }),

        listener(event) {
            if (event.keyCode == 40) this.currentFocus++;
            else if (event.keyCode == 38) this.currentFocus--;
            else if (event.keyCode == 13) {
                if (!this.customers[this.currentFocus]) return;
                this.existingCustomerSelected(this.customers[this.currentFocus]._id);
            }
            if (this.currentFocus < 0) this.currentFocus = this.customers.length - 1;
            if (this.currentFocus > this.customers.length - 1) this.currentFocus = 0;
            if (!this.$refs.searchResult)
                return
            let ul = this.$refs.searchResult
            ul.scrollTop = this.currentFocus * ul.scrollHeight / this.customers.length
        },
        updateValue(value) {
            // this.customer = value;
            this.$emit('input', value);
        },
        existingCustomerSelected(customerId) {
            this.$emit('existingCustomerSelected', customerId);
        },
        fetchCustomers() {
            return this.findCustomers(this.params)
        },
        validation(field){
            if (this.errors && (field in this.errors))
                return false
            else return null
        },

    }
}
</script>

